controllers.controller('ModifyTradeController', [
    '$scope', '$state', '$filter', '$q', '$timeout', '$ionicScrollDelegate',
    'config', 'constants', 'Utils', 'ErrorService', 'AssetService', 'OpenTradeService',
    'API', 'UserService', 'InvestCalcService', 'CurrencyConvertService',
    'LocaleService', 'PnlMarginService', 'Storage', 'ServerTimeService', 'UserControl',
    function ($scope, $state, $filter, $q, $timeout, $ionicScrollDelegate,
              config, Const, Utils, ErrorService, AssetService, OpenTradeService,
              API, UserService, InvestCalcService, CurrencyConvertService,
              LocaleService, PnlMarginService, Storage, ServerTimeService, UserControl) {

        $scope.user = UserService.get();
        if ($scope.user && !$scope.user.activeTradingAccount) {
            $state.go('signupPersonalProfile', {cache: false});
        }
        $scope.clientTimeZone = ServerTimeService.timeZoneOffset >= 0 ? '+' + ServerTimeService.timeZoneOffset.toString() : ServerTimeService.timeZoneOffset.toString();

        $scope.isFooter = true;
        $scope.showPartialClose = false;
        $scope.partialCloseChecked = false;
        $scope.showFooter = function () {
            $scope.isFooter = true;
        };

        $scope.translate = LocaleService.translation;

        var orderId = $state.params.orderId;
        $scope.constants = Const;
        $scope.sltpAutoSet = Const.sltpAutoSet || false;
        $scope.trade = null;

        $scope.rate = {
            checked: false,
            value: 0
        };

        $scope.trade = OpenTradeService.collection.get({orderId: parseInt(orderId, 10)});
        $scope.user = UserService.get();

        var stopLimit = parseInt($scope.trade.asset.stopLevels / 10, 10);

        $scope.investAmount = {
            value: $scope.trade.lots
        };

        $scope.pow = Math.pow;

        var defaultPl = {
            checked: false,
            pips: {
                value: stopLimit || 0,
                lock: true,
                keyboard: "text"
            },
            rate: {
                value: 0,
                lock: false,
                keyboard: "text"
            }
        };

        var disabledPl = {
            checked: false,
            pips: {
                value: 0,
                lock: false,
                keyboard: "text"
            },
            rate: {
                value: 0,
                lock: false,
                keyboard: "text"
            }
        };


        $scope.loss = angular.copy(disabledPl);
        $scope.profit = angular.copy(disabledPl);

        $scope.lossOrigin = angular.copy(defaultPl);
        $scope.profitOrigin = angular.copy(defaultPl);

        $scope.keyboardModelName = null;
        $scope.isKeyboardShow = false;

        $scope.inputFocus = function (model, name, minval, maxval, digits, viewName) {
            if((model.hasOwnProperty('lock') && !model.lock)|| (model.hasOwnProperty('checked')&& !model.checked)){
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
                return;
            }
            console.log(model, name, minval, maxval, digits, viewName);
            $scope.isKeyboardShow = true;
            $scope.keyboardModelName = {
                model: model,
                name: name,
                minval: minval,
                maxval: maxval,
                digits: digits,
                viewName: viewName,
            };
            $scope.showFooter();
        };

        $scope.myCallback = function(arg){
            if(arg){
                _.set($scope, arg.name, arg.model.value);
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
            }
            else{
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
            }
        };

        //pl: profit/loss, type: pips/rate
        $scope.lock = function (pl, type) {
            //hide footer
            $scope.isFooter = false;

            //unlock all fields and make their type=text
            unlockAll($scope[pl]);

            //lock current field
            $scope[pl][type].lock = true;

            if(type === 'pips') {
                // switch from rate value to pips value - if pips value is negative convert to positive
                $scope[pl][type].value = Math.abs($scope[pl][type].value);
                assetWatcher();
            }

            //change field type to number only for android
            if (Storage.get('platform') === 'android') {
                $scope[pl][type].keyboard = 'number';
            }

            //scroll to bottom
            $ionicScrollDelegate.scrollBottom(true);
        };

        //turn off all locked properties
        function unlockAll(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && obj[prop].hasOwnProperty('lock')) {
                    obj[prop].lock = false;
                }
                if (obj.hasOwnProperty(prop) && obj[prop].hasOwnProperty('keyboard')) {
                    obj[prop].keyboard = "text";
                }
            }
        }

        function resetObj(obj, defObj) {
            var def = angular.copy(defObj);
            delete def.checked;
            angular.merge(obj, def);
        }

        $scope.pnlData = PnlMarginService.data;

        var lossCheckWatch = $scope.$watch('loss.checked', function (newVal, oldVal) {
            //turn on loss - reset to default
            if (newVal !== oldVal && newVal) {
                resetObj($scope.loss, defaultPl);
            }
            //turn off loss - clear all fields
            if (newVal !== oldVal && !newVal) {
                $scope.loss = angular.copy(disabledPl);
            }
        });

        var profitCheckWatch = $scope.$watch('profit.checked', function (newVal, oldVal) {
            //turn on profit - reset to default
            if (newVal !== oldVal && newVal) {
                resetObj($scope.profit, defaultPl)
            }
            //turn off profit - clear all fields
            if (newVal !== oldVal && !newVal) {
                $scope.profit = angular.copy(disabledPl);
            }
        });

        var lossPipsWatch = $scope.$watch('loss.pips.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.loss.rate.lock) {
                $scope.loss.rate.value = calcLossRate();
            }
        });

        var lossRateWatch = $scope.$watch('loss.rate.value', function (newVal, oldVal) {
            if (newVal !== oldVal && !$scope.loss.pips.lock) {
                $scope.loss.pips.value = parseInt(calcLossPips(), 10);
            }
        });

        var profitPipsWatch = $scope.$watch('profit.pips.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.profit.rate.lock) {
                $scope.profit.rate.value = calcProfitRate();
            }
        });

        var profitRateWatch = $scope.$watch('profit.rate.value', function (newVal, oldVal) {
            if (newVal !== oldVal && !$scope.profit.pips.lock) {
                $scope.profit.pips.value = parseInt(calcProfitPips(), 10);
            }
        });


        function assetWatcher() {
            if ($scope.loss.checked) {
                //if loss field is not locked - calculate if automatically
                if (!$scope.loss.rate.lock) {
                    $scope.loss.rate.value = calcLossRate();
                    $scope.lossOrigin.rate.value = $scope.loss.rate.value;
                }
                //pips field is not locked - calculate if automatically
                if (!$scope.loss.pips.lock) {
                    $scope.loss.pips.value = parseInt(calcLossPips(), 10);
                    $scope.lossOrigin.pips.value = $scope.loss.pips.value;
                }
            }

            if ($scope.profit.checked) {
                //if loss field is not locked - calculate if automatically
                if (!$scope.profit.rate.lock) {
                    $scope.profit.rate.value = calcProfitRate();
                    $scope.profitOrigin.rate.value = $scope.profit.rate.value;
                }
                //pips field is not locked - calculate if automatically
                if (!$scope.profit.pips.lock) {
                    $scope.profit.pips.value = parseInt(calcProfitPips(), 10);
                    $scope.profitOrigin.pips.value = $scope.profit.pips.value;
                }
            }
        }

        var assetWatch = $scope.$watchGroup(['trade.asset.bid', 'trade.asset.ask'], function (newVal, oldVal) {
            if (newVal && oldVal && (newVal[0] !== oldVal[0] ||  newVal[1] !== oldVal[1])) {
                return assetWatcher();
            }
        });


        if ($scope.trade.takeProfit > 0) {
            $scope.profit.checked = true;
            $scope.profit.rate.value = $scope.trade.takeProfit;
            $scope.profit.rate.lock = true;

            $scope.profitOrigin.rate.value = $scope.profit.rate.value;
        }

        if ($scope.trade.stopLoss > 0) {
            $scope.loss.checked = true;
            $scope.loss.rate.value = $scope.trade.stopLoss;
            $scope.loss.rate.lock = true;

            $scope.lossOrigin.rate.value = $scope.loss.rate.value;
        }
        assetWatcher();

        $scope.requiredMargin = function () {
            var baseVal = 0,
                requiredMargin,
                user = UserService.get();

            if ($scope.trade.asset && parseFloat($scope.trade.lots) > 0) {
                requiredMargin = InvestCalcService.getRequiredMargin(parseFloat($scope.trade.lots), $scope.trade.asset, user);
                baseVal = requiredMargin;

                baseVal = CurrencyConvertService.doConvert($scope.trade.asset.convAssetsMargin, baseVal, $scope.trade.action, $scope.trade.asset.profitMode);
            }

            return baseVal;
        };

        //calculate takeProfit or stopLoss from pips/rate
        function calcProfitPrice(action, pointsRateVal, pointsRateStatus, sltp, investAmount) {
            if (!$scope.trade) return;

            var user = UserService.get(),
                openPrice = $scope.trade.openPrice,
                currentPrice = InvestCalcService.updatedPrice(action, $scope.trade.asset),
                closePrice = pointsRateStatus === 1 ?
                    InvestCalcService.getClosePrice(action, $scope.trade.asset, currentPrice, parseFloat(pointsRateVal), sltp) :
                    pointsRateVal,
                lots = investAmount,
                assetCurrency = $scope.trade.asset.currency,
                userCurrency = user.currency,
                pairVal = InvestCalcService.getPairVal(action, openPrice, closePrice, $scope.trade.asset.digits),
                baseVal;

            if ($scope.trade.asset.profitMode === 0) {
                assetCurrency = $scope.trade.asset.outputName.slice(-3);
            }

            if ($scope.trade.asset.profitMode < 2) {
                baseVal = pairVal * $scope.trade.asset.contractSize * lots;
            } else {
                baseVal = pairVal * ($scope.trade.asset.tickPrice / $scope.trade.asset.tickSize) * lots;
            }

            baseVal = CurrencyConvertService.doConvert($scope.trade.asset.convAssets, baseVal, action, $scope.trade.asset.profitMode);

            return parseFloat(baseVal);
        }

        //loss calculations
        function calcLossRate() {
            var digits = $scope.trade.asset.digits,
                points = InvestCalcService.getPoints(parseFloat($scope.loss.pips.value) * 10, digits);

            return $scope.loss.checked ? calcLoss($scope.trade.action, InvestCalcService.updatedPrice($scope.trade.action, $scope.trade.asset), points, digits) : 0;
        }

        function calcLossPips() {
            var rateRaw = 0,
                pips = 0;

            if ($scope.trade.action.match(/^sell/)) {
                rateRaw = $scope.loss.rate.value - InvestCalcService.updatedPrice($scope.trade.action, $scope.trade.asset);
            }
            if ($scope.trade.action.match(/^buy/)) {
                rateRaw = InvestCalcService.updatedPrice($scope.trade.action, $scope.trade.asset) - $scope.loss.rate.value;
            }
            pips = InvestCalcService.fromPoints(rateRaw / 10, $scope.trade.asset.digits);

            return pips.toFixed(0)
        }

        $scope.calcLossValue = function () {
            if (!$scope.trade) return;

            var pipsRate = $scope.loss.pips.lock ? 1 : 2,
                pipsRateValue = pipsRate === 1 ? $scope.loss.pips.value * 10 : $scope.loss.rate.value,
                lossValue = calcProfitPrice($scope.trade.action, pipsRateValue, pipsRate, 'stopLoss', $scope.trade.lots);
            return $scope.loss.checked ? lossValue : 0;
        };

        //profit calculations
        function calcProfitRate() {
            var digits = $scope.trade.asset.digits,
                points = InvestCalcService.getPoints(parseFloat($scope.profit.pips.value) * 10, digits);

            return $scope.profit.checked ? calcProfit($scope.trade.action, InvestCalcService.updatedPrice($scope.trade.action, $scope.trade.asset), points, digits) : 0;
        }

        function calcProfitPips() {
            var rateRaw = 0,
                pips = 0;

            if ($scope.trade.action.match(/^sell/)) {
                rateRaw = InvestCalcService.updatedPrice($scope.trade.action, $scope.trade.asset) - $scope.profit.rate.value;
            }
            if ($scope.trade.action.match(/^buy/)) {
                rateRaw = $scope.profit.rate.value - InvestCalcService.updatedPrice($scope.trade.action, $scope.trade.asset);
            }
            pips = InvestCalcService.fromPoints(rateRaw / 10, $scope.trade.asset.digits);

            return pips.toFixed(0);
        }

        $scope.calcProfitValue = function () {
            if (!$scope.trade) return;

            var pipsRate = $scope.profit.pips.lock ? 1 : 2,
                pipsRateValue = pipsRate === 1 ? $scope.profit.pips.value * 10 : $scope.profit.rate.value,
                profitValue = calcProfitPrice($scope.trade.action, pipsRateValue, pipsRate, 'takeProfit', $scope.trade.lots);
            return $scope.profit.checked ? profitValue : 0;
        };


        function calcProfit(action, price, points, digits) {
            if (action.match(/^sell/)) {
                return (price - points);
            }

            if (action.match(/^buy/)) {
                return (price + points);
            }
        }

        function calcLoss(action, price, points, digits) {
            if (action.match(/^sell/)) {
                return (price + points);
            }

            if (action.match(/^buy/)) {
                return (price - points);
            }
        }

        $scope.pipValue = function () {
            if ($scope.trade.asset && parseFloat($scope.trade.lots) > 0) {
                return calcProfitPrice('buy', 10, 1, 'takeProfit', $scope.trade.lots);
            }
            return 0;
        };

        function validateBuySell() {
            if (!$scope.trade) return;

            var action = $scope.trade.action,
                asset = $scope.trade.asset,
                profit = ($scope.profit.pips.lock ? calcProfitRate() : parseFloat($scope.profit.rate.value)) || 0,
                loss = ($scope.loss.pips.lock ? calcLossRate() : parseFloat($scope.loss.rate.value)) || 0;
            function stopLimitCheck() {
                if (profit === 0) {
                    return parseFloat($scope.loss.pips.value) >= stopLimit;
                } else if (loss === 0) {
                    return parseFloat($scope.profit.pips.value) >= stopLimit;
                } else {
                    return parseFloat($scope.loss.pips.value) >= stopLimit
                        && parseFloat($scope.profit.pips.value) >= stopLimit;
                }
            }

            if (action.match(/^buy/)) {
                if (profit === 0 && loss === 0) {
                    return true;
                } else if (profit === 0) {
                    return (asset.markupBid() > loss) && stopLimitCheck();
                } else if (loss === 0) {
                    return (asset.markupBid() < profit) && stopLimitCheck();
                } else {
                    return ((asset.markupBid() < profit && asset.markupBid() > loss)) && stopLimitCheck();
                }
            }

            if (action.match(/^sell/)) {
                if (profit === 0 && loss === 0) {
                    return true;
                } else if (profit === 0) {
                    return (asset.markupAsk() < loss) && stopLimitCheck();
                } else if (loss === 0) {
                    return (asset.markupAsk() > profit) && stopLimitCheck();
                } else {
                    return ((asset.markupAsk() > profit && asset.markupAsk() < loss)) && stopLimitCheck();
                }
            }
        }


        $scope.validate = function () {
            if (!$scope.trade) return;

            var isValidated = validateBuySell();

            return isValidated
        };

        $scope.closeTradeValidate = function () {
            if (!$scope.trade) return;
            return ($scope.investAmount.value >= $scope.trade.asset.stepLot && $scope.investAmount.value <= $scope.trade.lots)
        };

        $scope.isModified = function () {
            if ($scope.loss.checked === !$scope.trade.stopLoss ||
                $scope.profit.checked === !$scope.trade.takeProfit
            ) {
                return true;
            }
            return (
                $scope.loss.checked && (($scope.loss.pips.value !== $scope.lossOrigin.pips.value) || ($scope.loss.rate.value !== $scope.lossOrigin.rate.value)) ||
                $scope.profit.checked && (($scope.profit.pips.value !== $scope.profitOrigin.pips.value) || ($scope.profit.rate.value !== $scope.profitOrigin.rate.value))
            );
        };

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            isProcess: false,
            back: "root.app.openTrades"
        };

        $scope.modal = angular.copy(modalDefaults);

        function checkTrade(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'ModifyTradeController',
                    type: Const.error.type.VALIDATION,
                    code: data.Description || 'orderFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.modifyTrade = function () {
            var trade = {
                OrderID: $scope.trade.orderId,
                OpenPrice: parseFloat(InvestCalcService.getOpenPrice($scope.trade.action, $scope.trade.asset)),
                StopLoss: ($scope.loss.pips.lock ? calcLossRate() : parseFloat($scope.loss.rate.value)) || 0,
                TakeProfit: ($scope.profit.pips.lock ? calcProfitRate() : parseFloat($scope.profit.rate.value)) || 0
            };

            $scope.modal.isProcess = true;
            $scope.modal.textTitle = LocaleService.translation.messages.orderProcessing;
            $scope.modal.state = true;


            return API.mt4UpdatePosition(trade)
                .then(checkTrade)
                .then(function (data) {

                    $scope.modal.textTitle = LocaleService.translation.messages.modifyTrade;
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = ['#' + data.Trade.OrderID + '&zwj;', LocaleService.translation.successupdated].join(' ');
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                })
                .catch(function (error) {
                    $scope.modal.textTitle = LocaleService.translation.messages.orderFailed;
                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                })
        };

        $scope.openPartialClose = function () {
            $scope.investAmount = {
                value: $scope.trade.lots
            };
            $scope.showPartialClose = true;
        };
        $scope.cencelPartialClose = function () {
            $scope.showPartialClose = false;
        };

        $scope.closeTrade = function () {
            var tradeToClose = {
                ClosePrice: $scope.trade.closePrice(),
                OrderID: $scope.trade.orderId,
                Lots: parseFloat($scope.investAmount.value)
            };
            $scope.modal.state = true;
            $scope.modal.isProcess = true;
            $scope.modal.textTitle = LocaleService.translation.messages.orderProcessing;

            return API.mt4ClosePosition(tradeToClose)
                .then(checkTrade)
                .then(function (data) {
                    var action = Const.actionsId[data.Trade.Cmd].replace('_limit', '').replace('_stop', ''),
                        price = data.Trade.OpenPrice.toFixed(data.Trade.Digits);
                    $scope.modal.textTitle = LocaleService.translation.closeTrade;
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = [
                        "#" + data.Trade.OrderID + '&zwj;',
                        LocaleService.translation[action],
                        tradeToClose.Lots,
                        data.Trade.OutputName,
                        LocaleService.translation.at,
                        price,
                        '<br/>',
                        LocaleService.translation.closedAt,
                        Utils.decimalRound(data.Trade.ClosePrice, data.Trade.Digits)
                    ].join(' ');

                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                })
                .catch(function (error) {
                    $scope.modal.textTitle = LocaleService.translation.closeTrade;
                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                });
        };

        function clear() {
            log('clear modify trade controller');
            assetWatch();
            lossCheckWatch();
            profitCheckWatch();
            lossPipsWatch();
            lossRateWatch();
            profitPipsWatch();
            profitRateWatch();
            $scope.showPartialClose = false;
            $scope.pnlData = null;
            $scope.trade = null;
            $scope.user = null;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            var state = UserControl.getState();
            state && $state.go(state, {cache: false});

            return UserService.kycCheck();
        });

        $scope.$on('$ionicView.beforeLeave', clear);
        $scope.$on('clear', clear);

    }]);
